<script setup lang="ts">
import {useWM} from "../composables/WM";
import WMModal from "./WMModal.vue";
import {computed} from "vue";

const {getWmData} = useWM();
const wmData = getWmData();

const visibleBackdrop1 = computed(() => wmData.value.sideModals.length && !wmData.value.modals.length);
const visibleBackdrop2 = computed(() => wmData.value.modals.length);

</script>

<template>
	<template v-if="wmData.sideModals.length || wmData.modals.length">
		<div class="wm__backdrop" v-if="visibleBackdrop1">backdrop 1</div>
		<div class="wm__side-modals">
			<WMModal v-for="modal of wmData.sideModals" :key="modal" :modal="modal" container-css-class="side-modal__container"
					 title-css-class="side-modal__title" close-css-class="side-modal__close"/>
		</div>
		<div class="wm__backdrop" v-if="visibleBackdrop2">backdrop 2</div>
		<div class="wm__modals">
			<WMModal v-for="modal of wmData.modals" :key="modal" :modal="modal" container-css-class="modal__container"
					 title-css-class="modal__title" close-css-class="modal__close"/>
		</div>
	</template>
</template>

<style scoped>

</style>
